<div class="row">
  @if (labelName) {
    <div class="col-md-4 col-12">
      <label class="control-label" for="{{ labelName ? labelName : 'efan' }}">
        <span [ngClass]="required ? 'required' : ''">*</span>
        {{ labelName }}
      </label>
    </div>
  }
  <div [ngClass]="{ 'col-md-8 col-12': labelName, 'col-12': !labelName }">
    <input
      (blur)="emitBlur()"
      (ngModelChange)="changeModel($event)"
      [ngClass]="{
        requiredField: !isValid && !submitted,
        errorRequiredField: !isValid && submitted,
      }"
      [ngModel]="inputModel"
      [ngModelOptions]="{ standalone: true }"
      class="form-control"
      id="{{ labelName ? labelName : 'efan' }}"
      name="efan"
      placeholder=""
      type="text"
    />
  </div>
  @if (environment.useDebugMode) {
    <pre>
      inputModel: {{ inputModel }}
      isValid {{ isValid }}</pre>
  }
  @if (submitted && !isValid) {
    <div class="col-12 errorText" id="validationError">
      <i class="fa fa-circle-o fa-lg circle-position"></i>
      <i class="fa fa-exclamation exclamation-position"></i>
      <p class="col ps-2 ms-4 input-validation-text">
        Enter a valid efan of length 10.
      </p>
    </div>
  }
  @if (!submitted || isValid) {
    <div class="col-12">
      <p></p>
    </div>
  }
</div>
